export default class DebugOverlay {
  init(root) {
    this.container = document.createElement('div')
    this.container.className = 'debug-container'

    this.toggleButton = document.createElement('button')
    this.toggleButton.className = 'debug-toggle'
    this.toggleButton.title = 'Toggle System Telemetry'
    this.toggleButton.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
      </svg>
    `
    this.toggleButton.addEventListener('click', () => this.toggle())

    this.element = document.createElement('aside')
    this.element.className = 'debug-overlay hidden'

    this.container.appendChild(this.toggleButton)
    this.container.appendChild(this.element)
    root.appendChild(this.container)
   }

  toggle() {
    this.element.classList.toggle('hidden')
   }

  update({ fps, nodeCount, linkCount, selectedCount, clusterCount, averageDistance, gravityStrength, camera }) {
    if (!this.element) {
      return
     }

    this.element.innerHTML = `
       <div class="debug-overlay__title">SYSTEM TELEMETRY</div>
       <div class="debug-overlay__row"><span>FPS</span><strong>${fps}</strong></div>
       <div class="debug-overlay__row"><span>Nodes</span><strong>${nodeCount}</strong></div>
       <div class="debug-overlay__row"><span>Links</span><strong>${linkCount}</strong></div>
       <div class="debug-overlay__row"><span>Selected</span><strong>${selectedCount}</strong></div>
       <div class="debug-overlay__row"><span>Clusters</span><strong>${clusterCount}</strong></div>
       <div class="debug-overlay__row"><span>Avg Distance</span><strong>${averageDistance.toFixed(2)}</strong></div>
       <div class="debug-overlay__row"><span>Gravity</span><strong>${gravityStrength.toFixed(2)}</strong></div>
       <div class="debug-overlay__row"><span>Camera</span><strong>${camera.x.toFixed(1)}, ${camera.y.toFixed(1)}</strong></div>
     `
   }
}